import type { FC } from "react";

import { cn, makeBreakpointClassName } from "@/ui/lib/utils";
import {
  GRID_DEFAULTS,
  TGridProps,
  GRID_RESPONSIVE_COLUMNS_CLASS_MAP,
  GRID_RESPONSIVE_GAP_CLASS_MAP,
} from "@/ui/components/layout/Grid";

export const Grid: FC<TGridProps> = (
  {
    tag: Tag = GRID_DEFAULTS.tag,
    columns = GRID_DEFAULTS.columns,
    gap = GRID_DEFAULTS.gap,
    className,
    children,
    ...props
  },
) => {

  return (
    <Tag
      {...props}
      data-component="Grid"
      className={cn(
        "grid w-full",
        makeBreakpointClassName(columns, GRID_RESPONSIVE_COLUMNS_CLASS_MAP, GRID_DEFAULTS.columns),
        makeBreakpointClassName(gap, GRID_RESPONSIVE_GAP_CLASS_MAP, GRID_DEFAULTS.gap),
        className,
      )}
    >
      { children }
    </Tag>
  );
};

Grid.displayName = "Grid";
